import React, { useEffect, useState, useRef, useCallback } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { useDragNDropContext } from '../../../../../hooks/useDragNDropContext/useDragNDropContext';
import GalaxyAnimation from '../GalaxyAnimation/GalaxyAnimation';

function SplashPage() {
  const [animationState, setAnimationState] = useState('dropped');

  const [showAnimation, setShowAnimation] = useState<boolean>(false);

  const {
    isDragging, isDropping, setIsDropping,
  } = useDragNDropContext();

  const shouldCancelRef = useRef(false);

  const startAnimating = () => {
    shouldCancelRef.current = false;
    setShowAnimation(true);
    document.body.classList.add('animating');
  };

  // destroy animations
  const stopAnimating = useCallback(() => {
    shouldCancelRef.current = true;
    if (!showAnimation) {
      return;
    }
    setTimeout(() => {
      if (!shouldCancelRef.current) {
        return;
      }
      setAnimationState('');
      setTimeout(() => {
        setIsDropping(false);
        setShowAnimation(false);
        document.body.classList.remove('animating');
      }, 200);
    }, 75);
  }, [setIsDropping, showAnimation]);

  // open animation
  const playExpandAnimation = useCallback(() => {
    startAnimating();
    setAnimationState('expand');
  }, []);

  // closing animation where arrow shoots up
  const playDropAnimation = useCallback(() => {
    playExpandAnimation();
    setTimeout(() => {
      setAnimationState('dropped');
    }, 800);
  }, [playExpandAnimation]);

  useEffect(() => {
    // play drop animation once on page load
    playDropAnimation();
  }, [playDropAnimation]);

  useEffect(() => {
    // when dragging over drop zone
    if (isDragging) {
      shouldCancelRef.current = false;
      if (!showAnimation) {
        playExpandAnimation();
      }
    }
    // when drag leave from drop zone
    if (!isDragging) {
      stopAnimating();
    }
    // when file has been dropped over drop zone
    if (isDropping) {
      playDropAnimation();
    }
  }, [isDragging, isDropping, playDropAnimation, playExpandAnimation, showAnimation, stopAnimating]);

  return (
    <AnimationContainer>
      <Underlay showAnimation={!showAnimation} />
      {
        showAnimation && (
          <GalaxyAnimation
            status={animationState}
            onReadyToRemove={stopAnimating}
          />
        )
      }
    </AnimationContainer>
  );
}

const UnderlayFadeOutKeyframes = keyframes`
  from {
    opacity: 1;
    visibility: visible;
  }
  to {
    opacity: 0;
    visibility: hidden;
  }
`;

const Underlay = styled.div<{ showAnimation: boolean }>`
  position: fixed;
  width: 100%;

  background: white;
  animation: ${(props) => props.showAnimation
    && css`${UnderlayFadeOutKeyframes} 0.7s ease forwards`};
`;

const AnimationContainer = styled.div`
  z-index: 9999;
  overflow-y: hidden;
  overflow-x: hidden;
  pointer-events: none;
  width: 100%;


`;

export default SplashPage;
